import { render, staticRenderFns } from "./FileDeleteModal.vue?vue&type=template&id=ce5af0fa&scoped=true&"
import script from "./FileDeleteModal.vue?vue&type=script&lang=js&"
export * from "./FileDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./FileDeleteModal.vue?vue&type=style&index=0&id=ce5af0fa&lang=scss&scoped=true&"
import style1 from "./FileDeleteModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5af0fa",
  null
  
)

export default component.exports